import type { TestimonialsContent, Branding } from '../../../lib/site-schema';

interface Props {
  content: TestimonialsContent;
  branding: Branding | null;
  compact?: boolean;
}

export default function TestimonialsSection({ content, branding, compact }: Props) {
  const primary = branding?.primaryColor || '#d97706';

  return (
    <div className={compact ? 'px-4 py-5' : 'px-6 py-10'}>
      {content.heading && (
        <div className="text-center mb-5">
          <h2
            className={`${compact ? 'text-sm' : 'text-xl'} font-bold`}
            style={{ color: '#292524', fontFamily: branding?.fontHeading, letterSpacing: '-0.01em' }}
          >
            {content.heading}
          </h2>
          <div className="w-10 h-0.5 mx-auto mt-2 rounded-full" style={{ background: primary }} />
        </div>
      )}
      <div className={`grid ${compact ? 'grid-cols-1 gap-2' : 'grid-cols-1 md:grid-cols-2 gap-4'}`}>
        {(content.reviews || []).map((review, i) => (
          <div
            key={i}
            className={`${compact ? 'p-3' : 'p-5'} rounded-xl relative`}
            style={{ background: '#fff', boxShadow: '0 1px 3px rgba(0,0,0,0.06)' }}
          >
            {/* Decorative quote mark */}
            <span
              className={`absolute ${compact ? 'text-2xl -top-1 right-2' : 'text-4xl top-2 right-4'} font-serif leading-none`}
              style={{ color: `${primary}15` }}
            >
              &ldquo;
            </span>

            <div className="flex gap-0.5 mb-2">
              {Array.from({ length: 5 }, (_, s) => (
                <span
                  key={s}
                  className={compact ? 'text-[10px]' : 'text-xs'}
                  style={{ color: s < review.rating ? primary : '#e7e5e4' }}
                >
                  ★
                </span>
              ))}
            </div>
            <p
              className={`${compact ? 'text-[10px] leading-relaxed' : 'text-xs leading-relaxed'} italic`}
              style={{ color: '#57534e' }}
            >
              &ldquo;{review.text}&rdquo;
            </p>
            <div className={`${compact ? 'mt-2' : 'mt-3'} flex items-center gap-2`}>
              {/* Avatar circle */}
              <div
                className={`${compact ? 'w-5 h-5 text-[8px]' : 'w-7 h-7 text-[10px]'} rounded-full flex items-center justify-center font-bold text-white shrink-0`}
                style={{ background: `linear-gradient(135deg, ${primary}, ${primary}cc)` }}
              >
                {review.name.charAt(0).toUpperCase()}
              </div>
              <div>
                <p
                  className={`${compact ? 'text-[9px]' : 'text-[11px]'} font-semibold`}
                  style={{ color: '#44403c' }}
                >
                  {review.name}
                </p>
                {review.role && (
                  <p className={`${compact ? 'text-[8px]' : 'text-[10px]'}`} style={{ color: '#a8a29e' }}>
                    {review.role}
                  </p>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
